//* █▀█ █▄▀
//* █▄█ █░█

type ContainerProps = {
  classNames?: string;
  isAvazTv?: boolean;
  width?: string;
  height?: string;
};

// █▀ █▀█ █▀▀ █ ▄▀█ █░░
// ▄█ █▄█ █▄▄ █ █▀█ █▄▄

export const FacebookIcon = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={classNames}>
    <title>Facebook</title>
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);

export const FacebookIconArticle = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 512 512"
    height="30"
    viewBox="0 0 512 512"
    width="30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="m512 256c0 127.78-93.62 233.69-216 252.89v-178.89h59.65l11.35-74h-71v-48.02c0-20.25 9.92-39.98 41.72-39.98h32.28v-63s-29.3-5-57.31-5c-58.47 0-96.69 35.44-96.69 99.6v56.4h-65v74h65v178.89c-122.38-19.2-216-125.11-216-252.89 0-141.38 114.62-256 256-256s256 114.62 256 256z"
        fill="#1877f2"
      />
      <path
        d="m355.65 330 11.35-74h-71v-48.021c0-20.245 9.918-39.979 41.719-39.979h32.281v-63s-29.296-5-57.305-5c-58.476 0-96.695 35.44-96.695 99.6v56.4h-65v74h65v178.889c13.034 2.045 26.392 3.111 40 3.111s26.966-1.066 40-3.111v-178.889z"
        fill="#fff"
      />
    </g>
  </svg>
);

export const InstagramIcon = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={classNames}>
    <title>Instagram</title>
    <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />
  </svg>
);

export const LinkedInIcon = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={classNames}>
    <title>LinkedIn</title>
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

// export const TwitterIcon = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
//   <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={classNames}>
//     <title>Twitter</title>
//     <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
//   </svg>
// );

export const TwitterIcon = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="16px"
    height="16px"
    viewBox="0 0 256 256"
    xmlSpace="preserve"
  >
    <title>Twitter</title>

    <defs></defs>
    <g
      stroke="none"
      strokeWidth={0}
      strokeDasharray="none"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      strokeMiterlimit={10}
      fill="white"
      fillRule="nonzero"
      opacity={1}
      //style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;"
      transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
    >
      <polygon
        stroke="none"
        strokeWidth={1}
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit={10}
        fill="white"
        fillRule="nonzero"
        opacity={1}
        points="24.89,23.01 57.79,66.99 65.24,66.99 32.34,23.01 "
        //style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
        transform="  matrix(1 0 0 1 0 0) "
      />
      <path
        stroke="none"
        strokeWidth={1}
        strokeDasharray="none"
        strokeLinejoin="miter"
        strokeMiterlimit={10}
        fill="#8b8b8b"
        fillRule="nonzero"
        opacity={1}
        d="M 45 0 L 45 0 C 20.147 0 0 20.147 0 45 v 0 c 0 24.853 20.147 45 45 45 h 0 c 24.853 0 45 -20.147 45 -45 v 0 C 90 20.147 69.853 0 45 0 z M 56.032 70.504 L 41.054 50.477 L 22.516 70.504 h -4.765 L 38.925 47.63 L 17.884 19.496 h 16.217 L 47.895 37.94 l 17.072 -18.444 h 4.765 L 50.024 40.788 l 22.225 29.716 H 56.032 z"
        //style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
        transform=" matrix(1 0 0 1 0 0) "
        strokeLinecap="round"
      />
    </g>
  </svg>
);

// export const TwitterIconArticle = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     version="1.1"
//     width="30px"
//     height="30px"
//     x="0"
//     y="0"
//     viewBox="0 0 112.197 112.197"
//     xmlSpace="preserve"
//     className=""
//   >
//     <g>
//       <g>
//         <circle cx="56.099" cy="56.098" r="56.098" fill="#55acee" data-original="#55acee" className="" />
//         <g>
//           <path
//             d="M90.461,40.316c-2.404,1.066-4.99,1.787-7.702,2.109c2.769-1.659,4.894-4.284,5.897-7.417    c-2.591,1.537-5.462,2.652-8.515,3.253c-2.446-2.605-5.931-4.233-9.79-4.233c-7.404,0-13.409,6.005-13.409,13.409    c0,1.051,0.119,2.074,0.349,3.056c-11.144-0.559-21.025-5.897-27.639-14.012c-1.154,1.98-1.816,4.285-1.816,6.742    c0,4.651,2.369,8.757,5.965,11.161c-2.197-0.069-4.266-0.672-6.073-1.679c-0.001,0.057-0.001,0.114-0.001,0.17    c0,6.497,4.624,11.916,10.757,13.147c-1.124,0.308-2.311,0.471-3.532,0.471c-0.866,0-1.705-0.083-2.523-0.239    c1.706,5.326,6.657,9.203,12.526,9.312c-4.59,3.597-10.371,5.74-16.655,5.74c-1.08,0-2.15-0.063-3.197-0.188    c5.931,3.806,12.981,6.025,20.553,6.025c24.664,0,38.152-20.432,38.152-38.153c0-0.581-0.013-1.16-0.039-1.734    C86.391,45.366,88.664,43.005,90.461,40.316L90.461,40.316z"
//             fill="#ffffff"
//             data-original="#f1f2f2"
//             className=""
//           />
//         </g>
//       </g>
//       <g></g>
//       <g></g>
//       <g></g>
//       <g></g>
//       <g></g>
//       <g></g>
//       <g></g>
//       <g></g>
//       <g></g>
//       <g></g>
//       <g></g>
//       <g></g>
//       <g></g>
//       <g></g>
//       <g></g>
//     </g>
//   </svg>
// );

export const TwitterIconArticle = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="31px"
    height="31px"
    viewBox="0 0 256 256"
    xmlSpace="preserve"
  >
    <defs></defs>
    <g
      stroke="none"
      strokeWidth={0}
      strokeDasharray="none"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      strokeMiterlimit={10}
      fill="none"
      fillRule="nonzero"
      opacity={1}
      //style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;"
      transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
    >
      <polygon
        stroke="none"
        strokeWidth={1}
        strokeDasharray="none"
        strokeLinecap="butt"
        strokeLinejoin="miter"
        strokeMiterlimit={10}
        fill="rgb(0,0,0)"
        fillRule="nonzero"
        opacity={1}
        points="24.89,23.01 57.79,66.99 65.24,66.99 32.34,23.01 "
        //style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
        transform="  matrix(1 0 0 1 0 0) "
      />
      <path
        stroke="none"
        strokeWidth={1}
        strokeDasharray="none"
        strokeLinejoin="miter"
        strokeMiterlimit={10}
        fill="rgb(0,0,0)"
        fillRule="nonzero"
        opacity={1}
        d="M 45 0 L 45 0 C 20.147 0 0 20.147 0 45 v 0 c 0 24.853 20.147 45 45 45 h 0 c 24.853 0 45 -20.147 45 -45 v 0 C 90 20.147 69.853 0 45 0 z M 56.032 70.504 L 41.054 50.477 L 22.516 70.504 h -4.765 L 38.925 47.63 L 17.884 19.496 h 16.217 L 47.895 37.94 l 17.072 -18.444 h 4.765 L 50.024 40.788 l 22.225 29.716 H 56.032 z"
        //style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: rgb(0,0,0); fill-rule: nonzero; opacity: 1;"
        transform=" matrix(1 0 0 1 0 0) "
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const ViberIcon = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={classNames}>
    <title>Viber</title>
    <path d="M11.4 0C9.473.028 5.333.344 3.02 2.467 1.302 4.187.696 6.7.633 9.817.57 12.933.488 18.776 6.12 20.36h.003l-.004 2.416s-.037.977.61 1.177c.777.242 1.234-.5 1.98-1.302.407-.44.972-1.084 1.397-1.58 3.85.326 6.812-.416 7.15-.525.776-.252 5.176-.816 5.892-6.657.74-6.02-.36-9.83-2.34-11.546-.596-.55-3.006-2.3-8.375-2.323 0 0-.395-.025-1.037-.017zm.058 1.693c.545-.004.88.017.88.017 4.542.02 6.717 1.388 7.222 1.846 1.675 1.435 2.53 4.868 1.906 9.897v.002c-.604 4.878-4.174 5.184-4.832 5.395-.28.09-2.882.737-6.153.524 0 0-2.436 2.94-3.197 3.704-.12.12-.26.167-.352.144-.13-.033-.166-.188-.165-.414l.02-4.018c-4.762-1.32-4.485-6.292-4.43-8.895.054-2.604.543-4.738 1.996-6.173 1.96-1.773 5.474-2.018 7.11-2.03zm.38 2.602c-.167 0-.303.135-.304.302 0 .167.133.303.3.305 1.624.01 2.946.537 4.028 1.592 1.073 1.046 1.62 2.468 1.633 4.334.002.167.14.3.307.3.166-.002.3-.138.3-.304-.014-1.984-.618-3.596-1.816-4.764-1.19-1.16-2.692-1.753-4.447-1.765zm-3.96.695c-.19-.032-.4.005-.616.117l-.01.002c-.43.247-.816.562-1.146.932-.002.004-.006.004-.008.008-.267.323-.42.638-.46.948-.008.046-.01.093-.007.14 0 .136.022.27.065.4l.013.01c.135.48.473 1.276 1.205 2.604.42.768.903 1.5 1.446 2.186.27.344.56.673.87.984l.132.132c.31.308.64.6.984.87.686.543 1.418 1.027 2.186 1.447 1.328.733 2.126 1.07 2.604 1.206l.01.014c.13.042.265.064.402.063.046.002.092 0 .138-.008.31-.036.627-.19.948-.46.004 0 .003-.002.008-.005.37-.33.683-.72.93-1.148l.003-.01c.225-.432.15-.842-.18-1.12-.004 0-.698-.58-1.037-.83-.36-.255-.73-.492-1.113-.71-.51-.285-1.032-.106-1.248.174l-.447.564c-.23.283-.657.246-.657.246-3.12-.796-3.955-3.955-3.955-3.955s-.037-.426.248-.656l.563-.448c.277-.215.456-.737.17-1.248-.217-.383-.454-.756-.71-1.115-.25-.34-.826-1.033-.83-1.035-.137-.165-.31-.265-.502-.297zm4.49.88c-.158.002-.29.124-.3.282-.01.167.115.312.282.324 1.16.085 2.017.466 2.645 1.15.63.688.93 1.524.906 2.57-.002.168.13.306.3.31.166.003.305-.13.31-.297.025-1.175-.334-2.193-1.067-2.994-.74-.81-1.777-1.253-3.05-1.346h-.024zm.463 1.63c-.16.002-.29.127-.3.287-.008.167.12.31.288.32.523.028.875.175 1.113.422.24.245.388.62.416 1.164.01.167.15.295.318.287.167-.008.295-.15.287-.317-.03-.644-.215-1.178-.58-1.557-.367-.378-.893-.574-1.52-.607h-.018z" />
  </svg>
);

export const ViberIconArticle = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg height="30" viewBox="0 0 176 176" width="30" xmlns="http://www.w3.org/2000/svg">
    <g id="Layer_2" data-name="Layer 2">
      <g id="_12.viber" data-name="12.viber">
        <circle id="background" cx="88" cy="88" fill="#6f3faa" r="88" />
        <g id="icon" fill="#fff">
          <path d="m138.83 59.45v-.13c-1.18-4.78-4.26-9.72-8.3-13.88-4.72-4.88-10.73-8.71-16.47-9.95h-.12a137.68 137.68 0 0 0 -51.82 0h-.12c-10.66 2.31-22.23 13.45-24.81 23.83v.13a101.55 101.55 0 0 0 0 43.69v.12c1.84 7.4 8.24 15.18 15.62 19.88a30 30 0 0 0 7.79 3.61v11.58a4.66 4.66 0 0 0 8 3.23l11.74-12.2c2.54.14 5.1.22 7.64.22a138.13 138.13 0 0 0 25.91-2.46h.12c10.63-2.32 22.21-13.46 24.77-23.84v-.12a101.55 101.55 0 0 0 .05-43.71zm-9.29 41.55c-1.72 6.77-10.5 15.2-17.49 16.75a128.49 128.49 0 0 1 -27.56 2.25.59.59 0 0 0 -.48.2l-8.57 8.8-9.12 9.35a1.06 1.06 0 0 1 -1.83-.73v-19.2a.66.66 0 0 0 -.54-.65 16.94 16.94 0 0 1 -4.18-1.6c-5.94-3.17-11.93-9.67-13.31-15.17a92 92 0 0 1 0-39.49c1.71-6.74 10.54-15.15 17.48-16.71a128 128 0 0 1 48.11 0c3.85.86 8.25 3.79 11.69 7.39 2.83 2.93 5 6.31 5.8 9.35a92 92 0 0 1 0 39.46z" />
          <path d="m112.3 102a14.83 14.83 0 0 1 -6.36 7 15.21 15.21 0 0 1 -2.75.87c-1.07-.32-2.09-.54-3-.93a75.87 75.87 0 0 1 -20.9-12.29 52.64 52.64 0 0 1 -5.23-5.13 67.8 67.8 0 0 1 -10-15.26c-1.28-2.61-2.36-5.31-3.46-8-1-2.45.48-5 2-6.83a16 16 0 0 1 5.37-4 3.46 3.46 0 0 1 4.31 1 55.86 55.86 0 0 1 6.72 9.33 4.44 4.44 0 0 1 -1.25 6c-.5.35-1 .75-1.43 1.14a4.51 4.51 0 0 0 -1.08 1.14 3.13 3.13 0 0 0 -.24 2.77c1.93 5.31 4.86 9.74 9.24 12.85a23.88 23.88 0 0 0 4.76 2.61 7.25 7.25 0 0 0 3.58.88c2.18-.26 2.9-2.67 4.42-3.91a4.19 4.19 0 0 1 5-.23c1.62 1 3.18 2.13 4.74 3.23a52.31 52.31 0 0 1 4.45 3.4 3.52 3.52 0 0 1 1.11 4.36z" />
          <path d="" />
          <path d="m89.16 54h-.58z" />
          <path d="" />
          <path d="m90.87 54.08h-1.28c.41-.02.84 0 1.28 0z" />
          <path d="m113 84.05c-1 0-1.49-.85-1.56-1.78-.13-1.83-.23-3.67-.48-5.49a22.24 22.24 0 0 0 -3.14-8.65 23 23 0 0 0 -15.4-10.58c-1.44-.26-2.91-.32-4.36-.47-.92-.1-2.13-.16-2.33-1.3a1.57 1.57 0 0 1 1.55-1.78 6.26 6.26 0 0 1 .72 0 26.58 26.58 0 0 1 22 12 26.29 26.29 0 0 1 3.78 9.69c.38 2.16.52 4.38.69 6.58a1.54 1.54 0 0 1 -1.47 1.78z" />
          <path d="m107.59 79.38a3.82 3.82 0 0 1 -.12.88 1.47 1.47 0 0 1 -2.76.15 4.3 4.3 0 0 1 -.15-1.24 16.11 16.11 0 0 0 -1.3-6.51c-.2-.44-.42-.89-.67-1.32a14.56 14.56 0 0 0 -6.11-5.73 18 18 0 0 0 -4.86-1.5c-.74-.12-1.48-.19-2.22-.29a1.41 1.41 0 0 1 -1.33-1.57 1.39 1.39 0 0 1 1.55-1.38 20.26 20.26 0 0 1 8.43 2.2 17 17 0 0 1 7.45 7.36 19.22 19.22 0 0 1 1.84 5.9 7.93 7.93 0 0 1 .12.81c.05.6.07 1.2.12 1.94 0 .07.01.16.01.3z" />
          <path d="m100.74 78a1.3 1.3 0 0 1 -1.06 1h-.22a1.51 1.51 0 0 1 -1.52-1 2 2 0 0 1 -.12-.51 14.27 14.27 0 0 0 -.3-2 5.81 5.81 0 0 0 -2.14-3.35 5.66 5.66 0 0 0 -1.73-.84c-.79-.23-1.62-.17-2.4-.36a1.48 1.48 0 0 1 -1.2-1.71 1.55 1.55 0 0 1 1.63-1.24c4.58.33 8 2.53 8.88 7.44a11.77 11.77 0 0 1 .19 1.38 4 4 0 0 1 -.01 1.19z" />
        </g>
      </g>
    </g>
  </svg>
);

export const WhatsAppIcon = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={classNames}>
    <title>WhatsApp</title>
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
  </svg>
);

export const WhatsAppIconArticle = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="30px"
    height="30px"
    x="0"
    y="0"
    viewBox="0 0 176 176"
    xmlSpace="preserve"
    className=""
  >
    <g>
      <g id="Layer_2" data-name="Layer 2">
        <g id="_09.whatsapp" data-name="09.whatsapp">
          <circle id="background" cx="88" cy="88" fill="#25d366" r="88" data-original="#29a71a" className="" />
          <g id="icon" fill="#fff">
            <path
              d="m126.8 49.2a54.57 54.57 0 0 0 -87.42 63.13l-5.79 28.11a2.08 2.08 0 0 0 .33 1.63 2.11 2.11 0 0 0 2.24.87l27.55-6.53a54.56 54.56 0 0 0 63.09-87.21zm-8.59 68.56a42.74 42.74 0 0 1 -49.22 8l-3.84-1.9-16.89 4 .05-.21 3.5-17-1.88-3.71a42.72 42.72 0 0 1 7.86-49.59 42.73 42.73 0 0 1 60.42 0 2.28 2.28 0 0 0 .22.22 42.72 42.72 0 0 1 -.22 60.19z"
              fill="#ffffff"
              data-original="#ffffff"
              className=""
            />
            <path
              d="m116.71 105.29c-2.07 3.26-5.34 7.25-9.45 8.24-7.2 1.74-18.25.06-32-12.76l-.17-.15c-12.09-11.21-15.23-20.54-14.47-27.94.42-4.2 3.92-8 6.87-10.48a3.93 3.93 0 0 1 6.15 1.41l4.45 10a3.91 3.91 0 0 1 -.49 4l-2.25 2.92a3.87 3.87 0 0 0 -.35 4.32c1.26 2.21 4.28 5.46 7.63 8.47 3.76 3.4 7.93 6.51 10.57 7.57a3.82 3.82 0 0 0 4.19-.88l2.61-2.63a4 4 0 0 1 3.9-1l10.57 3a4 4 0 0 1 2.24 5.91z"
              fill="#ffffff"
              data-original="#ffffff"
              className=""
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const YouTubeIcon = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={classNames}>
    <title>YouTube</title>
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
  </svg>
);

export const ShareIcon = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={classNames}>
    <title>Share Icon</title>
    <path
      d="M10.0607 0.467041V4.38981C6.49756 4.38992 0 4.42901 0 15.5329C0.736667 8.10757 4.12081 8.06088 10.0607 8.0608V12.3447L16 6.4054L10.0607 0.467041Z"
      fill="white"
    />
  </svg>
);

// █▀▀ █░█ █▀▀ █░█ █▀█ █▀█ █▄░█
// █▄▄ █▀█ ██▄ ▀▄▀ █▀▄ █▄█ █░▀█

export const ChevronBottom = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={classNames}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    style={{
      filter: 'invert(80%) sepia(98%) saturate(0%) hue-rotate(245deg) brightness(97%) contrast(94%)',
    }}
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
  </svg>
);

export const ChevronRight = ({ width, height, classNames }: ContainerProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width={width}
    height={height}
    x="0"
    y="0"
    viewBox="0 0 128 128"
    xmlSpace="preserve"
    stroke="currentColor"
    id="Right_Arrow_4_Svg"
  >
    <g>
      <path
        id="Right_Arrow_4_"
        d="m44 108c-1.023 0-2.047-.391-2.828-1.172-1.563-1.563-1.563-4.094 0-5.656l37.172-37.172-37.172-37.172c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0l40 40c1.563 1.563 1.563 4.094 0 5.656l-40 40c-.781.781-1.805 1.172-2.828 1.172z"
        data-original="#000000"
        className={classNames}
      />
    </g>
  </svg>

  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   className={classNames}
  //   fill="none"
  //   viewBox="0 0 24 24"
  //   stroke="currentColor"
  //   // style={{
  //   //   filter:
  //   //     'invert(13%) sepia(5%) saturate(7%) hue-rotate(314deg) brightness(97%) contrast(80%)',
  //   // }}
  // >
  //   <path
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //     strokeWidth={2}
  //     d="M9 5l7 7-7 7"
  //   />
  // </svg>
);

export const ChevronUp = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg
    className={classNames}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      filter: 'invert(80%) sepia(98%) saturate(0%) hue-rotate(245deg) brightness(97%) contrast(94%)',
    }}
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7"></path>
  </svg>
);

export const ChevronLeft = ({ classNames = 'h-6 w-6 right-dark-mode' }: ContainerProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={classNames} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
  </svg>
);

// █░░ █ █▄░█ █▄▀
// █▄▄ █ █░▀█ █░█

export const LinkIcon = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg className={classNames} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
      id="Capa_4"
    ></path>
  </svg>
);

//Mobile share link

export const LinkIconMobile = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="30"
    height="30"
    x="0"
    y="0"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    className=""
  >
    <g>
      <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="256" x2="256" y1="512" y2="0">
        <stop stopOpacity="1" stopColor="#eeeeee" offset="0"></stop>
        <stop stopOpacity="1" stopColor="#eeeeee" offset="0.5028"></stop>
        <stop stopOpacity="1" stopColor="#eeeeee" offset="1"></stop>
      </linearGradient>
      <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="256" x2="256" y1="389.503" y2="122.5">
        <stop stopOpacity="1" stopColor="#333333" offset="0"></stop>
        <stop stopOpacity="1" stopColor="#333333" offset="1"></stop>
      </linearGradient>
      <g>
        <g>
          <circle
            cx="256"
            cy="256"
            fill="url(#SVGID_1_)"
            r="256"
            data-original="url(#SVGID_1_)"
            className="color-bg-avaztv"
            id="Capa_3"
          ></circle>
        </g>
        <g>
          <g>
            <path
              d="m403.287 213.165-124.353-88.998c-2.741-1.956-6.263-2.208-9.229-.669-2.967 1.521-4.823 4.572-4.823 7.909v44.733c-88.945 4.642-159.882 78.612-159.882 168.861v35.599c0 4.441 3.261 8.196 7.651 8.813 4.223.617 8.525-1.977 9.767-6.362l1.371-4.806c18.216-63.863 75.483-109.3 141.094-113.09v44.247c0 3.337 1.856 6.388 4.823 7.909 2.967 1.539 6.488 1.269 9.229-.669l124.353-88.998c2.325-1.669 3.713-4.363 3.713-7.24s-1.389-5.57-3.714-7.239z"
              fill="url(#SVGID_2_)"
              data-original="url(#SVGID_2_)"
              className="color-fill-avaztv"
              id="Capa_5"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

// COMMENTS ICON

export const CommentsIcon = ({ isAvazTv }: ContainerProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="30"
    height="30"
    x="0"
    y="0"
    viewBox="0 0 22 22"
    xmlSpace="preserve"
  >
    <g>
      <path
        d="m21.08 15.4.91 5.43a1.0217 1.0217 0 0 1 -.28.88 1.0068 1.0068 0 0 1 -.71.29 1.0284 1.0284 0 0 1 -.17-.01l-5.43-.91a10.8118 10.8118 0 0 1 -4.4.92 11 11 0 1 1 11-11 10.8118 10.8118 0 0 1 -.92 4.4z"
        fill="#eeeeee"
        data-original="#000000"
        id="Capa_2"
      ></path>
    </g>
  </svg>
);

export const DarkModeIconMoon = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    x="0"
    y="0"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    className={classNames}
  >
    <g>
      <g>
        <path
          d="m256.025 512c141.15 0 256-114.85 255.95-257.112 0-11.4-7.55-21.437-18.5-24.587-10.95-3.2-22.7 1.287-28.763 10.938-26.024 41.311-70.537 65.961-119.087 65.961-77.638 0-140.8-63.163-140.8-140.8 0-48.55 24.65-93.062 65.963-119.087 9.637-6.075 13.55-17.837 10.388-28.788s-13.751-18.525-25.151-18.525c-141.15 0-256 114.85-256 256s114.85 256 256 256zm-73.513-446.937c-18.638 29.887-28.887 64.763-28.887 101.337 0 105.875 86.125 192 192 192 36.688 0 71.688-10.3 101.625-29.075-29.55 76.825-104.125 131.475-191.225 131.475-112.925 0-204.8-91.875-204.8-204.8 0-86.838 54.325-161.225 131.287-190.937z"
          fill="#ffffff"
          data-original="#000000"
          className=""
        />
      </g>
    </g>
  </svg>
);

export const DarkModeIconSun = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="16"
    height="16"
    x="0"
    y="0"
    viewBox="0 0 512 512"
    xmlSpace="preserve"
    className=""
  >
    <g>
      <g fill="rgb(0,0,0)">
        <path
          d="m384 255.988c0-70.587-57.425-128-128-128s-128 57.413-128 128 57.425 128 128 128 128-57.413 128-128zm-128 76.8c-42.35 0-76.8-34.45-76.8-76.8s34.45-76.8 76.8-76.8 76.8 34.45 76.8 76.8-34.45 76.8-76.8 76.8z"
          fill="#ffffff"
          data-original="#000000"
          className=""
        ></path>
        <path
          d="m281.6 51.2v-25.6c0-14.138-11.462-25.6-25.6-25.6-14.137 0-25.6 11.462-25.6 25.6v25.6c0 14.125 11.463 25.6 25.6 25.6 14.138 0 25.6-11.475 25.6-25.6z"
          fill="#ffffff"
          data-original="#000000"
          className=""
        ></path>
        <path
          d="m437.025 74.975c-10-10-26.225-10-36.2 0l-18.1 18.1c-10 10-10 26.212 0 36.2 4.987 5 11.55 7.5 18.1 7.5s13.1-2.5 18.1-7.5l18.1-18.1c10-9.987 10-26.2 0-36.2z"
          fill="#ffffff"
          data-original="#000000"
          className=""
        ></path>
        <path
          d="m486.4 230.4h-25.6c-14.125 0-25.6 11.463-25.6 25.6 0 14.138 11.475 25.6 25.6 25.6h25.6c14.138 0 25.6-11.462 25.6-25.6 0-14.137-11.462-25.6-25.6-25.6z"
          fill="#ffffff"
          data-original="#000000"
          className=""
        ></path>
        <path
          d="m400.825 437.025c4.987 5 11.55 7.5 18.1 7.5s13.1-2.5 18.1-7.5c10-10 10-26.212 0-36.2l-18.1-18.1c-10-10-26.225-10-36.2 0-10 9.988-10 26.2 0 36.2z"
          fill="#ffffff"
          data-original="#000000"
          className=""
        ></path>
        <path
          d="m230.4 460.8v25.6c0 14.138 11.463 25.6 25.6 25.6 14.138 0 25.6-11.462 25.6-25.6v-25.6c0-14.125-11.462-25.6-25.6-25.6-14.137 0-25.6 11.475-25.6 25.6z"
          fill="#ffffff"
          data-original="#000000"
          className=""
        ></path>
        <path
          d="m74.975 437.025c5 5 11.55 7.5 18.1 7.5s13.113-2.5 18.1-7.5l18.1-18.1c10-10 10-26.212 0-36.2-9.975-10-26.2-10-36.2 0l-18.1 18.1c-10 9.987-10 26.2 0 36.2z"
          fill="#ffffff"
          data-original="#000000"
          className=""
        ></path>
        <path
          d="m0 256c0 14.138 11.462 25.6 25.6 25.6h25.6c14.125 0 25.6-11.462 25.6-25.6 0-14.137-11.475-25.6-25.6-25.6h-25.6c-14.138 0-25.6 11.463-25.6 25.6z"
          fill="#ffffff"
          data-original="#000000"
          className=""
        ></path>
        <path
          d="m129.275 129.275c10-9.988 10-26.2 0-36.2l-18.1-18.1c-9.975-10-26.2-10-36.2 0s-10 26.212 0 36.2l18.1 18.1c5 5 11.55 7.5 18.1 7.5s13.112-2.5 18.1-7.5z"
          fill="#ffffff"
          data-original="#000000"
          className=""
        ></path>
      </g>
    </g>
  </svg>
);

// █▀█ █▀▀ █▀ ▀█▀
// █▀▄ ██▄ ▄█ ░█░

export const MailIcon = ({ classNames = 'h-6 w-6' }: ContainerProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={classNames} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);

export const Logout = ({ classNames = 'h-[2rem] w-[2rem]' }: ContainerProps) => (
  <svg className={classNames} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
    ></path>
  </svg>
);

export const Profile = ({ classNames = 'h-[2rem] w-[2rem]' }: ContainerProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={classNames} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
    />
  </svg>
);

export const Search = ({ classNames = 'h-[2rem] w-[2rem]' }: ContainerProps) => (
  <svg className={classNames} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
    ></path>
  </svg>
);

export const Close = ({ classNames = 'h-[2rem] w-[2rem]' }: ContainerProps) => (
  <svg className={classNames} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
  </svg>
);

export const Hamburger = ({ classNames = 'h-[2rem] w-[2rem]' }: ContainerProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={classNames} fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

export const SearchHamburger = ({ classNames = 'h-[2rem] w-[2rem]' }: ContainerProps) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={classNames} stroke="currentColor" fill="white">
    <path
      clipRule="evenodd"
      d="m2 3.25c-.41421 0-.75.33579-.75.75s.33579.75.75.75h13c.4142 0 .75-.33579.75-.75s-.3358-.75-.75-.75zm14 5.5c-2.8995 0-5.25 2.3505-5.25 5.25s2.3505 5.25 5.25 5.25 5.25-2.3505 5.25-5.25-2.3505-5.25-5.25-5.25zm-6.75 5.25c0-3.7279 3.0221-6.75 6.75-6.75s6.75 3.0221 6.75 6.75c0 1.5938-.5524 3.0585-1.4761 4.2133l1.2564 1.2564c.2929.2929.2929.7677 0 1.0606s-.7677.2929-1.0606 0l-1.2564-1.2564c-1.1548.9237-2.6195 1.4761-4.2133 1.4761-3.7279 0-6.75-3.0221-6.75-6.75zm-7.25-.75c-.41421 0-.75.3358-.75.75s.33579.75.75.75h5c.41421 0 .75-.3358.75-.75s-.33579-.75-.75-.75zm-.75-4.25c0-.41421.33579-.75.75-.75h5c.41421 0 .75.33579.75.75s-.33579.75-.75.75h-5c-.41421 0-.75-.33579-.75-.75z"
      fillRule="evenodd"
    />
  </svg>
);

export const Flag = ({ classNames = 'h-[2rem] w-[2rem]' }: ContainerProps) => (
  <svg className={classNames} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9"
    ></path>
  </svg>
);

export const Pencil = ({ classNames = 'h-[2rem] w-[2rem]' }: ContainerProps) => (
  <svg className={classNames} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
    ></path>
  </svg>
);
